<template>
  <div class="review-modal" v-if="reviewClose">
    <div class="booking-requested">
      <div class="success-gif-container">
        <img
          src="@/assets/timeslot-images/4386-connection-error.gif"
          loading="lazy"
          width="170"
          alt=""
        />
      </div>
      <!--      <a-->
      <!--          data-w-id="caac9a15-5baa-ef5a-3411-d43737a55cc4"-->
      <!--          href="#"-->
      <!--          class="link-block-5 w-inline-block"-->
      <!--      >-->
      <!--        <img-->
      <!--            @click="cancel"-->
      <!--            src="@/assets/timeslot-images/cancel.svg"-->
      <!--            loading="lazy"-->
      <!--            alt=""-->
      <!--        />-->
      <!--      </a>-->
      <!--      <div class="div-block-86-active">-->
      <!--        <img-->
      <!--            :src="-->
      <!--            singleProfessional.customerDisplayPicture ||-->
      <!--              require('@/assets/timeslot-images/profileImg.svg')-->
      <!--          "-->
      <!--            loading="lazy"-->
      <!--            class="prof-image"-->
      <!--            alt=""-->
      <!--        />-->
      <!--      </div>-->
      <div class="div-block-52">
        <h1 class="modal-heading">Review elapsed bookings</h1>
      </div>
      <p class="paragraph-7">
        Review all the sessions that you have had with professionals
        <!--        <strong>{{ profName }}</strong-->
      </p>
      <!--      <div class="rating-link-wrapper">-->
      <!--        <a href="#" class="rating-card w-inline-block">-->
      <!--          <img src="@/assets/timeslot-images/Star-Active.svg" loading="lazy" alt="">-->
      <!--          &lt;!&ndash;          <img src="@/assets/timeslot-images/Star-Inactive.svg" loading="lazy" alt="" v-else>&ndash;&gt;-->
      <!--        </a>-->
      <!--        <a href="#" class="rating-card w-inline-block"  @click="toggleStar2">-->
      <!--          <img src="@/assets/timeslot-images/Star-Active.svg" loading="lazy" alt="" v-if="star2">-->
      <!--          <img src="@/assets/timeslot-images/Star-Inactive.svg" loading="lazy" alt="" v-else>-->
      <!--        </a>-->
      <!--        <a href="#" class="rating-card w-inline-block"  @click="toggleStar3">-->
      <!--          <img src="@/assets/timeslot-images/Star-Active.svg" loading="lazy" alt="" v-if="star3">-->
      <!--          <img src="@/assets/timeslot-images/Star-Inactive.svg" loading="lazy" alt="" v-else>-->
      <!--        </a>-->
      <!--        <a href="#" class="rating-card w-inline-block"  @click="toggleStar4">-->
      <!--          <img src="@/assets/timeslot-images/Star-Active.svg" loading="lazy" alt="" v-if="star4">-->
      <!--          <img src="@/assets/timeslot-images/Star-Inactive.svg" loading="lazy" alt="" v-else>-->
      <!--        </a>-->
      <!--        <a href="#" class="rating-card w-inline-block"  @click="toggleStar5">-->
      <!--          <img src="@/assets/timeslot-images/Star-Active.svg" loading="lazy" alt="" v-if="star5">-->
      <!--          <img src="@/assets/timeslot-images/Star-Inactive.svg" loading="lazy" alt="" v-else>-->
      <!--        </a>-->
      <!--      </div>-->
      <!--      <div class="textfield-review">-->
      <!--        <div class="div-block-187">-->
      <!--          <textarea-->
      <!--              placeholder="Write a review"-->
      <!--              maxlength="5000"-->
      <!--              id="field-4"-->
      <!--              name="field-4"-->
      <!--              data-name="field"-->
      <!--              class="review-textfield w-input"-->
      <!--              v-model="reviewModel.comment"-->
      <!--          ></textarea>-->
      <!--        </div>-->
      <!--      </div>-->
      <div
        data-w-id="caac9a15-5baa-ef5a-3411-d43737a55cdc"
        class="button-15 w-button"
        @click="buttonAction"
      >
        Review
      </div>
    </div>
  </div>
</template>

<script>
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import { mapState } from "vuex";

export default {
  name: "ReviewWarningModal",
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    })
  },
  props: {
    reviewClose: Boolean
  },
  methods: {
    buttonAction() {
      if (this.userInfo.userRole.toLowerCase() === "customer") {
        RouterUtils.changeRouteUrlTo("/customer-bookings");
      } else {
        RouterUtils.changeRouteUrlTo("/professional-bookings");
      }
      if (this.reviewClose) {
        this.reviewClose = false;
      }
    }
  }
};
</script>

<style scoped>
.success-gif-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
